export default "/assets/images/twilight-blue.jpg?e4dcbcfa6efa16a3a327ea6d7ce6f720";